import React, {useState, useCallback} from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel, Grid
} from '@mui/material'
import {useDropzone} from 'react-dropzone'
import PropTypes from 'prop-types'

export const ACCESS_TYPE_LIST = [
    {value: "PRIVATE", description: "PRIVADO"},
    {value: "PUBLIC", description: "PÚBLICO"}
]
const ACCESS_TYPE_DEFAULT = "PUBLIC"

const UploadModal = ({open, onClose, onSubmit, supportedTypes}) => {
    const [filename, setFilename] = useState('')
    const [file, setFile] = useState(null)
    const [accessType, setAccessType] = useState(ACCESS_TYPE_DEFAULT)

    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0]
        if (!file) return

        setFile(file)

        if (!filename) {
            const nomeOriginal = file.name
            const lastDotIndex = nomeOriginal.lastIndexOf('.')
            const nomeSemExtensao = lastDotIndex !== -1
                ? nomeOriginal.slice(0, lastDotIndex)
                : nomeOriginal

            setFilename(nomeSemExtensao)
        }
    }, [filename])

    const supportedMimeTypes = Object.values(supportedTypes).map(({mediaType}) => mediaType)
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: supportedMimeTypes.reduce((acc, ext) => {
            acc[ext] = []
            return acc
        }, {})
    })

    const handleSubmit = () => {
        if (file && filename) {
            onSubmit({file: file, filename: filename, accessType: accessType})
            setFilename('')
            setFile(null)
            setAccessType(ACCESS_TYPE_DEFAULT)
            onClose(false)
        }
    }

    const onCloseModal = () => {
        setFilename('')
        setFile(null)
        onClose(false)
    }

    return (
        <Dialog open={open} onClose={onCloseModal} maxWidth="sm" fullWidth>
            <DialogTitle>Upload de Documento</DialogTitle>
            <DialogContent>
                <Grid container direction={"column"} spacing={2}>
                    <Grid item>
                        <TextField
                            label="Nome do Arquivo"
                            fullWidth
                            margin="normal"
                            value={filename}
                            onChange={(e) => setFilename(e.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <FormControl fullWidth>
                            <InputLabel id="select-type-access">Nível de Acesso</InputLabel>
                            <Select
                                displayEmpty
                                id="select-type-access"
                                label="Nível de Acesso"
                                onChange={(event) => setAccessType(event.target.value)}
                                value={accessType}
                            >
                                {ACCESS_TYPE_LIST
                                    .map((select, index) =>
                                        <MenuItem key={index} value={select.value}>{select.description}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <Box
                            {...getRootProps()}
                            sx={{
                                border: '2px dashed #aaa',
                                borderRadius: 2,
                                padding: 3,
                                textAlign: 'center',
                                mt: 2,
                                cursor: 'pointer',
                                bgcolor: isDragActive ? '#f0f0f0' : 'inherit',
                            }}
                        >
                            <input {...getInputProps()} />
                            {file ? (
                                <Typography variant="body1">{file.name}</Typography>
                            ) : isDragActive ? (
                                <Typography>Solte o arquivo aqui...</Typography>
                            ) : (
                                <Typography>Clique ou arraste um arquivo aqui</Typography>
                            )}
                            <Typography variant="caption" sx={{mt: 1, display: 'block', color: 'text.secondary'}}>
                                {Object.keys(supportedTypes).join(', ')}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCloseModal}>Cancelar</Button>
                <Button
                    onClick={handleSubmit}
                    disabled={!filename || !file}
                    variant="contained"
                    color="primary"
                >
                    Enviar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

UploadModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    supportedTypes: PropTypes.object
}

export default UploadModal